/**
 * MobileRoute Component
 * Handles routing based on device screen size
 * - On mobile: Shows mobile component or redirects to dashboard
 * - On desktop: Shows desktop component
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMobile } from '../context/MobileContext';

function MobileRoute({ desktopComponent, mobileComponent, redirectMobile = false }) {
  const { isMobile } = useMobile();

  // If on mobile device
  if (isMobile) {
    // If redirectMobile is true, redirect to dashboard (mobile only has access to dashboard)
    if (redirectMobile) {
      return <Navigate to="/dashboard" replace />;
    }
    // Otherwise show the mobile component if provided
    return mobileComponent || desktopComponent;
  }

  // On desktop, show the desktop component
  return desktopComponent;
}

export default MobileRoute;
